import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

const ContactDealsModelSchema = z
  .object({
    id: z.string(),
    deal_id: z.string().nullish(),
    contact_id: z.string().nullish(),
    relationship_category_id: z.string().nullish(),
    title: z.string().nullish(),
    current: z.boolean().nullish(),
    from: z.string().nullish(),
    to: z.string().nullish()
  })
  .strict()

export const ContactDealsModelFields = makeFieldKeys(ContactDealsModelSchema)

export type ContactDealsModel = z.infer<typeof ContactDealsModelSchema>

function validateContactDealsModel(data: unknown): ContactDealsModel {
  try {
    return validateWithZodSchema(ContactDealsModelSchema, data, 'contact deals model')
  } catch (error) {
    throw new Error(`Contact deals model validation failed: ${error}`)
  }
}
